import React, { useMemo, useState } from 'react';
import Header from '../components/Header';
import Body from '../components/Body';
import Footer from '../components/Footer';
import { getStoredUserProfile } from '../utils/authStorage';
import '../styles/Layout.css';

export default function MainPage({ user: userProp }) {
  const fallbackUser = useMemo(() => {
    return getStoredUserProfile();
  }, []);
  const user = userProp || fallbackUser;
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <div className="page-shell">
      <Header user={user} isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} showMenu={false} />
      <div className="page-main">
        <Body isMenuOpen={isMenuOpen} user={user} />
      </div>
      <Footer />
    </div>
  );
}
